<div *ngIf="fileNames.length > 0" class="margin-bottom">
    <mat-label><b>{{field.displayName}}</b></mat-label>
    <div *ngFor="let fileName of fileNames">{{fileName}}</div>
</div>
<app-aaos-spinner [isLoading]="loading"></app-aaos-spinner>